import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=50f2dc5b&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"
import style0 from "./Companies.vue?vue&type=style&index=0&id=50f2dc5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2dc5b",
  null
  
)

export default component.exports